import { ActionWorkflowNode, OrderWorkflowNode, TreatmentType } from 'app/core/enums';
import { StepBarNode } from '../step-bar';
import { Organizations } from 'app/core/constants';

export const ORDER_WORKFLOW_NODE_CONFIGS: StepBarNode[] = [
  {
    key: OrderWorkflowNode.SelectTeeth,
    title: 'general.selectTeeth',
    treatmentType: [TreatmentType.SmileDesign, TreatmentType.Veneers, TreatmentType.NeerCrystal, TreatmentType.Moment],
    disableForOrganizations: [Organizations.neer.id],
  },
  {
    key: OrderWorkflowNode.SelectArch,
    title: 'general.selectArch',
    treatmentType: [TreatmentType.NightGuard],
  },
  {
    key: OrderWorkflowNode.DesignStyle,
    title: 'general.designStyle',
    treatmentType: [TreatmentType.SmileDesign, TreatmentType.Veneers, TreatmentType.NeerCrystal, TreatmentType.Moment],
  },
  {
    key: OrderWorkflowNode.DesignStyle,
    title: 'general.guardType',
    treatmentType: [TreatmentType.NightGuard],
  },
  {
    key: OrderWorkflowNode.TreatmentInfo,
    title: 'general.treatmentInfo',
  },
  {
    key: OrderWorkflowNode.TreatmentInfoAdvanced,
    title: 'general.treatmentInfoAdvanced',
    treatmentType: [TreatmentType.Veneers, TreatmentType.NeerCrystal, TreatmentType.Moment],
  },
  {
    key: OrderWorkflowNode.ReviewAndSubmit,
    title: 'general.reviewAndSubmit',
  },
];

export function filterOrderWorkflowNodeConfigs(
  nodes: StepBarNode[],
  isTreatmentInfoAdvancedEnabled: boolean,
  action?: ActionWorkflowNode | string | null
): StepBarNode[] {
  return isTreatmentInfoAdvancedEnabled &&
    action !== ActionWorkflowNode.Reprint &&
    action !== ActionWorkflowNode.UpgradeToVeneers
    ? nodes
    : nodes.filter(node => node.key !== OrderWorkflowNode.TreatmentInfoAdvanced);
}
